const percentagesValues = [
    'tx_indice_propriedade',
    'taxa_industrias_transformacao',
    'taxa_eletrecidade_gas',
    'taxa_agua_esgoto_residuos',
    'taxa_construcao',
    'taxa_comercio_veiculos',
    'taxa_transporte_armazenagem',
    'taxa_alojamento_alimentacao',
    'taxa_informacao_comunicacao',
    'taxa_atividades_imobiliarias',
    'taxa_administracao_publica',
    'taxa_saude_servicos_sociais',
    'taxa_artes_recreacao',
    'taxa_outros',
    'taxa_servicos_domesticos',
    'taxa_org_internacionais',
    'tx_despesas_consumo',
    'tx_alimentacao',
    'tx_alimentacao_fora',
    'tx_alimentacao_dentro',
    'tx_artigos_limpeza',
    'tx_calcados',
    'tx_eletrodomesticos',
    'tx_gastos_medicamentos',
    'tx_higiene_cuidados_pessoais',
    'tx_material_construcao',
    'tx_recreacao_e_cultura',
    'tx_despesas_viagens',
    'tx_livros_material_escolar',
    'tx_matriculas_mensalidades',
    'tx_mobiliarios_artigos_lar',
    'tx_outras_despesas_saude',
    'tx_vestuario',
    'taxa_domicilios_2010_2022',
    'tx_aumento_do_ativo',
    'tx_alimentacao_bebidas',
    'tx_habitacao',
    'tx_saude',
    'tx_aumento_do_ativo',
    'tx_educacao',
    'tx_despesas_consumo',
    'tx_vestuario'
];


const formatInfo = (key, value) => {


    if (percentagesValues.includes(key)) {
        const formattedValue = new Intl.NumberFormat("pt-BR", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }).format(value);

        return `${formattedValue}%`;
    }


    if (typeof value === "string") {
        const num = Number(value);
        if (!isNaN(num)) {
            if (Number.isInteger(num)) {
                return new Intl.NumberFormat("pt-BR", {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(num);
            }
            const formattedValue =  new Intl.NumberFormat("pt-BR", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
            }).format(num);

            if (percentagesValues.includes(key)) {
                return `${formattedValue}%`;
            } else {
                return formattedValue;
            }

        }

        return value;
    }

    if (typeof value === "number") {

        if (Number.isInteger(value)) {
            return new Intl.NumberFormat("pt-BR", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(value);
        }

        const formattedValue = new Intl.NumberFormat("pt-BR", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }).format(value);

        if (percentagesValues.includes(key)) {
            return `${formattedValue}%`;
        } else {
            return formattedValue;
        }

    }

    return value;
}

export default formatInfo;
